import { render, staticRenderFns } from "./newInvoice.vue?vue&type=template&id=a5668fb8&"
import script from "./newInvoice.vue?vue&type=script&lang=js&"
export * from "./newInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports